export default __webpack_public_path__ + "static/media/javascript.563ad941.svg";